







































































































































import { Component, Prop, Watch, Mixins } from "vue-property-decorator";
import { BvTableFieldArray, BvTableCtxObject } from "bootstrap-vue";
import { VIPCapabilityRefreshTableMixin } from "@/mixins/VIPCapabilityMixin";
import CapabilityStatusBadge from "./CapabilityStatusBadge.vue";
import IpBadge from "../ip/IpBadge.vue";
import {
	VIPIp,
	IVIPCapability,
	VIPCapabilityRest,
	VipCapabilityStatus,
	getVipCapabilityStatusList,
	VIPCapability,
	VipCapabilityType,
	getVipCapabilityTypeList,
} from "@/loader/public";
import dayjs, { ConfigType } from 'dayjs';

@Component({
	components: {
		CapabilityStatusBadge,
		IpBadge,
	}
})
export default class CapabilitiesTable extends Mixins(VIPCapabilityRefreshTableMixin) {
	@Prop({ type: VIPIp, default: null })
	public ip!: VIPIp | null;

	@Prop({ type: String, default: null })
	public status!: VipCapabilityStatus | null;

	@Prop({ type: Boolean, default: false })
	public possibilities!: boolean;

	@Prop({ type: Boolean, default: null })
	public expired!: boolean | null;

	@Prop({ type: Boolean, default: null })
	public renewable!: boolean | null;

	@Prop({ type: Boolean, default: null })
	public renewed!: boolean | null;

	public statuses: VipCapabilityStatus[] = [];
	public types: VipCapabilityType[] = [];
	public ips: number[] = [];

	public get capabilityStatuses() {
		return getVipCapabilityStatusList();
	}

	public get capabilityTypes() {
		return getVipCapabilityTypeList();
	}

	public get fields(): BvTableFieldArray {
		let fields: BvTableFieldArray = [];
		fields.push({
			key: "status",
			label: "Statut",
		});
		if (!this.ip) {
			fields.push({
				key: "ip",
				label: "IP",
			});
		}
		fields.push({
			key: "date",
			label: "Début",
			sortable: true,
			formatter(value: ConfigType | null) {
				let d = dayjs(value || undefined);
				return d.isValid() ? d.format("L") : ""
			}
		});
		fields.push({
			key: "end",
			label: "Fin",
			sortable: true,
			formatter(value: ConfigType | null) {
				let d = dayjs(value || undefined);
				return d.isValid() ? d.format("L") : ""
			}
		});
		fields.push({
			key: "capability_request",
			label: "Demande",
		});
		return fields;
	}

	public get statusVariant(): (item: IVIPCapability) => string {
		return (item: IVIPCapability) => {
			switch (item.status) {
				case VipCapabilityStatus.sent:
					return "warning";
				case VipCapabilityStatus.refused:
					return "outline-danger";
				case VipCapabilityStatus.signed:
					return "success";
				case VipCapabilityStatus.draft:
				default:
					return "outline-info";
			}
		}
	}

	public getCapabilities(context: BvTableCtxObject, callback: Function) {
		let method = this.possibilities ? VIPCapabilityRest.getPossibilities : VIPCapabilityRest.list;
		method({
			page: context.currentPage,
			per_page: context.perPage,
			search: context.filter?.toString() || undefined,
			// @ts-ignore
			orderby: context.sortBy || undefined,
			order: context.sortDesc ? "DESC" : "ASC",
			fk_ip: !this.hideFilters ? this.ips : this.ip?.id || undefined,
			status: !this.hideFilters ? this.statuses : this.status,
			type: !this.hideFilters ? this.types : undefined,
			expired: this.expired !== null ? this.expired : undefined,
			renewable: this.renewable !== null ? this.renewable : undefined,
			renewed: this.renewed !== null ? this.renewed : undefined,
		}).then(result => {
			this.setResult(callback, result);
		});
		return null;
	}

	public viewCapability(capability: VIPCapability) {
		this.$router.push({ name: "Capability", params: { id: capability.id.toString() } });
	}

	@Watch("ips")
	public ipsChanged(newValue: any, oldValue: any) {
		this.filterChanged();
	}

	@Watch("statuses")
	public statusesChanged(newValue: any, oldValue: any) {
		this.filterChanged();
	}

	@Watch("types")
	public typesChanged(newValue: any, oldValue: any) {
		this.filterChanged();
	}
}
